import { I18n } from 'react-redux-i18n';

const entityInterfaceSearchFields = (searchFieldValues, categoryList ) => {
    return {
        rows: [
            {
                hasTopBreak: false,
                hasBottomBreak: false,
                fields: [
                    {
                        id: "name",
                        label: I18n.t("entityInterfaces.list.name"),
                        type: "text",
                        value: searchFieldValues.name.value,
                    },
                    {
                        id: "category",
                        label: I18n.t("entityInterfaces.list.category"),
                        type: "dropdown",
                        value: searchFieldValues.category.value,
                        data: categoryList,
                        validator: () => { }
                    }
                ]
            }
        ]
    }
};

export {
    entityInterfaceSearchFields
}